import { GeoJSON } from 'geojson'

import { createPaginatedNetworkRequestHook } from '@/utils/createPaginatedNetworkRequestHook'

import { NetworkParams } from '@/lib/core/hooks/usePaginatedNetworkResource'
import { ListFilters } from '@/lib/core/interfaces/common.types'

export type LocationFilters = ListFilters

export interface Location {
  id: number
  name: string
  type: string
  address: string
  linkedAlertsCount: number
  lastUpdated: string
  enabledAlert: boolean
  geoJson: GeoJSON
  geometryType: string | null
}
export const useLocationsList = createPaginatedNetworkRequestHook<
  Location,
  NetworkParams<LocationFilters>
>('v1/locations/')
